import React, { FunctionComponent } from "react";

import { BackgroundColorWrapper, Badge, BadgeVariant, FontWeight, LocalizationLoader, LocalizationProvider, Skeleton, Text } from "@multiweb/reactComponents";
import { ParticipantType } from "@multiweb/types/multiweb";
import { FlagColor } from "@multiweb/types/react";
import { LOC_KEY_ROLE, LOC_KEY_USER } from "./lockeys";
import { ParticipantTypeAttributeProps } from "./ParticipantTypeAttribute";

export const ParticipantTypeAttributeComponent: FunctionComponent<ParticipantTypeAttributeProps> = ({
    record,
    attributeName,
}) => {
    const participantType: ParticipantType = record?.[attributeName]?.value;
    const backgroundColor: FlagColor = participantType === ParticipantType.Role ? "red" : "aqua";
    const locKey = participantType === ParticipantType.Role ? LOC_KEY_ROLE : LOC_KEY_USER;

    if (!record) {
        return (
            <Skeleton width={30} height={20} />
        );
    }

    return (
        <BackgroundColorWrapper color={backgroundColor}>
            <Badge variant={BadgeVariant.backgroundAttr}>
                <LocalizationLoader locKey={locKey}>
                    <LocalizationProvider locKey={locKey}>
                        {({ text }) => <Text fontWeight={FontWeight.bold} value={text}></Text>}
                    </LocalizationProvider>
                </LocalizationLoader>
            </Badge>
        </BackgroundColorWrapper>
    );
};
